import { render } from "./escolaEditar.vue?vue&type=template&id=4063dcee&scoped=true"
import script from "./escolaEditar.vue?vue&type=script&lang=js"
export * from "./escolaEditar.vue?vue&type=script&lang=js"

import "./escolaEditar.vue?vue&type=style&index=0&id=4063dcee&scoped=true&lang=css"
import "./escolaEditar.vue?vue&type=style&index=1&id=4063dcee&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4063dcee"]])

export default __exports__